
export class TranslationMessagesList {
   
    english: string;
    key: string;
    id: string;
    seletedLanguage: string;
    actionFlag: boolean
    constructor(id:string, key:string, english: string, seletedLanguage:string , actionFlag:boolean){
        this.key = key;
        this.id = id;
       this.english = english;
       this.seletedLanguage = seletedLanguage;
       this.actionFlag = actionFlag;
        
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/translation-messages/translation-messages/translations-messages.list.ts